import API from 'src/services/api';

import { IInfo } from './types';
import { AxiosResponse } from 'axios';

const infoApi = {
  async fetchInfo(): Promise<AxiosResponse<IInfo>> {
    return await API.get(`/info`);
  },
};

export default infoApi;
